import React from "react";
import Folder from "../folder";
import AboutProject from "./aboutproject";
import AboutUs from "./aboutus";
import Reference from "./reference";

const About = ({
  isAboutUsOpen,
  isAboutProjectOpen,
  isReferenceOpen,
  lang,
  manageWindow,
  manageSelection,
  selected,
}) => {
  const title = "About";

  return (
    <>
      <Folder
        title={title}
        manageWindow={manageWindow}
        manageSelection={manageSelection}
        selected={title === selected}
      />
      <Reference
        isOpen={isReferenceOpen}
        manageWindow={manageWindow}
        lang={lang}
      />
      <AboutUs isOpen={isAboutUsOpen} manageWindow={manageWindow} lang={lang} />
      <AboutProject
        isOpen={isAboutProjectOpen}
        manageWindow={manageWindow}
        lang={lang}
      />
    </>
  );
};

export default About;
